import script from "./FloatingSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingSelect.vue?vue&type=script&setup=true&lang=js"

import "./FloatingSelect.vue?vue&type=style&index=0&id=0dc7831f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dc7831f"]])

export default __exports__